<template>
  <div class="w-100">
    <div class="text-center" v-if="status == 'W'">
      <h4><i class="fa fa-spin fa-spinner"></i> Gerando Relatório</h4>
    </div>
    <div class="text-center text-danger" v-if="status == 'E'">
      <h4><i class="fa fa-times-circle"></i> Erro ao Gerar Relatório</h4>
    </div>
    <div class="w-100 d-flex justify-content-center" v-if="status == 'C'">
      <div>
        <button @click="downloadCSV" class="px-5 btn btn-sm btn-success mb-1"><i class="fa fa-file-csv"></i> Baixar CSV</button>
        <br>
        <button class="px-5 btn btn-sm btn-warning"><i class="fa fa-file-pdf"></i> Baixar PDF</button>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  props: {
    status: {
      default: 'Vendas'
    },
    status: {
      default: 'X'
    },
    report: {
      required: false
    }
  },
  methods: {
    downloadCSV: function () {
      Axios.post('/teacher/report/print/csv', {
        name: this.name,
        data: this.report
      })
    }
  }
}
</script>

<style>

</style>
